<div class="ribbon-container">
  <img [src]="'svg/demo_ribbon.svg' | assetVersion">
  <div class="ribbon-text">DEMO DATA</div>
  <div class="ribbon-text-line-2">Connect to See Yours</div>
</div>